import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/couple-watching-sunset.webp';
import imageMobileWebp from './images/couple-watching-sunset-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='fixed-variable-annuities-financial-planning'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      disableBottomPadding={false}
      reverseContent={false}
      // content
      subHeadingText={<>Make a plan for <WidowBlock>tomorrow today.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            Research shows that people are the happiest when they know how much they can safely spend month to month.<sup>3</sup> A fixed or variable annuity can help by giving you the chance to grow your savings for retirement.{' '}
            <Link
              id='fixed-variable-annuities-financial-planning-learn-more-link'
              variant='primaryDeemphasize'
              linkUrl='/life-and-money/how-variable-annuities-can-help-you-save-for-retirement-early/'
              ariaLabel='Find out more about variable annuities'>
              Find out more
            </Link>
            {' '}about how a fixed or variable annuity can fit into your comprehensive financial plan. Your Northwestern Mutual advisor will work with you on a retirement plan specifically tailored to your goals.
          </Typography>
          <Link
            id='financial-planning-section-cta'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='couple watching a sunset'
      imageSrcDefault={imageDesktopWebp}
      imageSrcMobile={imageMobileWebp}
    />
  );
};
